
{
  "familyId": "MET-GEW-SCHATTEN",
  "questions": [
    {
      "id": "MET-GEW-SCHATTEN-001",
      "familyId": "MET-GEW-SCHATTEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_schatten",
      "questionType": "multiple_choice",
      "question": "Een leerling tilt zijn schooltas op. Hoeveel weegt een volle schooltas ongeveer?",
      "options": ["5 kg", "50 g", "50 kg", "500 g"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gewicht schatten — referentiepunten",
            "content": "Gebruik referentiepunten: een pak melk = 1 kg, een appel = 150 g, een schooltas = 3-7 kg, een volwassene = 60-90 kg. Een schooltas is zwaarder dan een pak melk maar lichter dan een kind.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "weight_estimate_schoolbag",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Een volle schooltas weegt ongeveer 3-7 kg, dus ~5 kg is een goede schatting. Dat is vergelijkbaar met 5 pakken melk. 50 g is veel te licht (dat is een ei), 50 kg is veel te zwaar (dat is een kind), en 500 g is ook te licht (dat is een brood).",
        "solutionSteps": [
          "Referentie: 1 pak melk = 1 kg",
          "Een schooltas = meerdere boeken + etui",
          "Schatting: 3-7 kg → ~5 kg",
          "Check: 5 pakken melk klinkt realistisch ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Een volle schooltas weegt ongeveer 5 kg.",
          "1": "50 gram is veel te licht — dat is ongeveer het gewicht van een ei. Een schooltas met boeken is veel zwaarder. Onthoud: gram is voor lichte dingen, kilogram voor zwaardere.",
          "2": "50 kg is veel te zwaar — dat is het gewicht van een kind! Een schooltas is zwaar, maar niet zó zwaar. Onthoud: vergelijk met bekende gewichten.",
          "3": "500 gram (een half kilo) is te licht voor een volle schooltas. Dat is ongeveer het gewicht van een brood. Een schooltas met boeken weegt meer. Onthoud: een boek alleen weegt al ~300-500 g."
        }
      }
    },
    {
      "id": "MET-GEW-SCHATTEN-002",
      "familyId": "MET-GEW-SCHATTEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_schatten",
      "questionType": "multiple_choice",
      "question": "Een boer weegt een koe. Hoeveel weegt een volwassen koe ongeveer?",
      "options": ["600 kg", "60 kg", "6.000 kg", "6 kg"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gewicht van dieren",
            "content": "Referentiepunten: een kat = 4 kg, een hond = 20-40 kg, een mens = 60-90 kg, een koe = 400-800 kg, een olifant = 4.000-6.000 kg. Een koe is veel zwaarder dan een mens maar lichter dan een olifant.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "weight_estimate_cow",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Een volwassen koe weegt ongeveer 400-800 kg, dus ~600 kg is een goede schatting. Dat is ongeveer 8 keer het gewicht van een volwassen mens. 60 kg is het gewicht van een mens, 6.000 kg van een olifant, en 6 kg van een kat.",
        "solutionSteps": [
          "Referentie: een mens = ~75 kg",
          "Een koe is veel groter dan een mens",
          "Schatting: 400-800 kg → ~600 kg",
          "Check: ~8 × een mens klinkt realistisch ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Een volwassen koe weegt ongeveer 600 kg.",
          "1": "60 kg is het gewicht van een mens, niet van een koe. Een koe is veel groter en zwaarder. Onthoud: een koe weegt ~8 keer zoveel als een mens.",
          "2": "6.000 kg is het gewicht van een olifant, niet van een koe. Een koe is groot, maar niet zó groot. Onthoud: 6 ton = olifant, 600 kg = koe.",
          "3": "6 kg is het gewicht van een kat, niet van een koe. Een koe is honderden keren zwaarder dan een kat. Onthoud: vergelijk altijd met bekende referentiepunten."
        }
      }
    },
    {
      "id": "MET-GEW-SCHATTEN-003",
      "familyId": "MET-GEW-SCHATTEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_schatten",
      "questionType": "multiple_choice",
      "question": "Welk voorwerp weegt ongeveer 100 gram?",
      "options": ["een appel", "een fiets", "een munt van 1 euro", "een stoel"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gewicht schatten — 100 gram",
            "content": "100 gram is een handvol. Referenties: een munt = ~7 g, een appel = 100-200 g, een brood = 500 g, een fiets = 10-15 kg, een stoel = 3-5 kg.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "weight_estimate_100g",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Een appel weegt ongeveer 100-200 gram. Een munt van 1 euro weegt maar ~7 gram (veel te licht). Een fiets weegt 10-15 kg (veel te zwaar). Een stoel weegt 3-5 kg (ook te zwaar).",
        "solutionSteps": [
          "100 gram = een handvol",
          "Een appel = 100-200 g ✓",
          "Een munt = ~7 g (te licht)",
          "Een fiets = 10-15 kg (te zwaar)"
        ],
        "distractorExplanations": {
          "0": "Goed! Een appel weegt ongeveer 100-200 gram.",
          "1": "Een fiets weegt 10-15 kg, dat is 10.000-15.000 gram — veel meer dan 100 gram. Onthoud: 1 kg = 1.000 gram.",
          "2": "Een munt van 1 euro weegt maar ~7 gram — veel minder dan 100 gram. Je zou 14 munten nodig hebben voor 100 gram. Onthoud: munten zijn heel licht.",
          "3": "Een stoel weegt 3-5 kg, dat is 3.000-5.000 gram — veel meer dan 100 gram. Onthoud: meubels wegen kilogrammen, niet grammen."
        }
      }
    },
    {
      "id": "MET-GEW-SCHATTEN-004",
      "familyId": "MET-GEW-SCHATTEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_schatten",
      "questionType": "multiple_choice",
      "question": "Zet deze voorwerpen op volgorde van licht naar zwaar.",
      "options": [
        "munt → appel → schooltas → fiets",
        "appel → munt → fiets → schooltas",
        "munt → schooltas → appel → fiets",
        "fiets → schooltas → appel → munt"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gewichten vergelijken",
            "content": "Munt = ~7 g, appel = ~150 g, schooltas = ~5 kg, fiets = ~12 kg. Van licht naar zwaar: munt → appel → schooltas → fiets.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "weight_estimate_ordering",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Van licht naar zwaar: munt (~7 g) → appel (~150 g) → schooltas (~5 kg) → fiets (~12 kg). Onthoud: gram-voorwerpen zijn lichter dan kilogram-voorwerpen.",
        "solutionSteps": [
          "Munt: ~7 gram (lichtst)",
          "Appel: ~150 gram",
          "Schooltas: ~5 kg = 5.000 gram",
          "Fiets: ~12 kg = 12.000 gram (zwaarst)"
        ],
        "distractorExplanations": {
          "0": "Goed! Munt → appel → schooltas → fiets (van licht naar zwaar).",
          "1": "Een appel is zwaarder dan een munt, niet andersom. Een munt weegt ~7 g, een appel ~150 g. Onthoud: begin met het lichtste voorwerp.",
          "2": "Een schooltas (~5 kg) is veel zwaarder dan een appel (~150 g). De volgorde klopt niet. Onthoud: kilogrammen > grammen.",
          "3": "Dit is van zwaar naar licht, niet van licht naar zwaar. Lees de vraag goed: er wordt gevraagd van licht naar zwaar."
        }
      }
    },
    {
      "id": "MET-GEW-SCHATTEN-005",
      "familyId": "MET-GEW-SCHATTEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_schatten",
      "questionType": "fill_in",
      "question": "Een pak melk weegt 1 kg. Hoeveel pakken melk heb je nodig om hetzelfde gewicht als een schooltas (~5 kg) te krijgen? Typ het getal.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["5"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gewicht vergelijken met referentie",
            "content": "Een pak melk = 1 kg. Een schooltas = ~5 kg. Dus: 5 kg ÷ 1 kg = 5 pakken melk.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "weight_estimate_reference_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Een pak melk weegt 1 kg. Een schooltas weegt ~5 kg. Dus: 5 kg ÷ 1 kg = 5 pakken melk.",
        "solutionSteps": [
          "Pak melk = 1 kg",
          "Schooltas = ~5 kg",
          "5 kg ÷ 1 kg = 5 pakken melk"
        ]
      }
    }
  ]
}
